import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

const Footer = () => {
  return (
    <footer
      style={{
        marginTop: "auto",
        background: "linear-gradient(180deg, #0c3a69 0%, #082e54 100%)",
        color: "#fff",
        padding: "2.5rem 1rem",
      }}
    >
      <div className="grid align-items-center justify-content-between">
        {/* Col 1: Logo + Síguenos */}
        <div className="col-12 md:col-4 flex align-items-center gap-3 mb-4 md:mb-0">
          <img
            src={`${process.env.PUBLIC_URL}/images/Logo.png`}
            alt="Logo"
            height={56}
            style={{ filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.3))" }}
          />
          <div style={{ fontWeight: "700", fontSize: "1.2rem" }}>¡Síguenos!</div>
        </div>

        {/* Col 2: Contacto */}
        <div className="col-12 md:col-4 mb-4 md:mb-0">
          <div style={{ fontWeight: "700", fontSize: "1.1rem", marginBottom: "0.5rem" }}>
            Contacto
          </div>
          <div>965 100 7363</div>
          <div>mkt.digital@unicach.mx</div>
          <div>Campus Universitario Calz. Samuel León Brindis no.151</div>
          <div>Tuxtla Gutiérrez, Chiapas</div>
        </div>

        {/* Col 3: Suscripción */}
        <div className="col-12 md:col-4">
          <div style={{ fontWeight: "700", fontSize: "1.1rem", marginBottom: "0.25rem" }}>
            Suscríbete a nuestra lista de correo
          </div>
          <div style={{ opacity: 0.9, marginBottom: "0.5rem" }}>
            Descubre más sobre Marketing Digital.
          </div>

          <div className="flex align-items-center gap-2">
            <span className="p-input-icon-left flex-1">
              <InputText
                placeholder="Correo Electrónico"
                style={{
                  borderRadius: "9999px",
                  height: "2.5rem",
                  width: "100%",
                }}
              />
            </span>
            <Button
              label="Suscríbete"
              style={{
                borderRadius: "9999px",
                height: "2.5rem",
                backgroundColor: "#f2933f",
                borderColor: "#f2933f",
              }}
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
